export const leadTypes = [
  {
    icon: "ri-file-shield-2-line",
    title: "内部文件与合同",
    desc: "未公开的协议文本、审批单、会议纪要、内部通知与往来函件，能还原一件事的真实决策过程。",
    tags: ["纸质文件", "电子文档", "往来函件"],
  },
  {
    icon: "ri-money-cny-circle-line",
    title: "财务与资金流向",
    desc: "账目、报销凭证、转账记录、合同金额与实际支付的差异。数字不会说谎，差异往往就是入口。",
    tags: ["银行流水", "账簿", "报销凭证"],
  },
  {
    icon: "ri-hand-coin-line",
    title: "利益输送与不当获利",
    desc: "关联交易、定向关照、以权谋私的完整链路。我们关心的是链路，而不仅是单点传闻。",
    tags: ["关联方", "招投标", "定向合作"],
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "数据造假与违规操作",
    desc: "被修饰过的报表、被替换的样本、被清零的监测值。程序性违规往往比结果更值得追问。",
    tags: ["统计口径", "检测报告", "系统日志"],
  },
  {
    icon: "ri-user-voice-line",
    title: "职场不公与内部人证",
    desc: "你亲历的排挤、克扣、胁迫与违规指令。人证需要细节支撑，时间、地点、对话都算材料。",
    tags: ["亲历陈述", "沟通记录", "同事旁证"],
  },
  {
    icon: "ri-plant-line",
    title: "环境与公共安全",
    desc: "偷排、超标、隐患整改走过场。这类线索直接影响公众，我们优先级最高。",
    tags: ["监测数据", "现场影像", "整改记录"],
  },
];

export const submitFlow = [
  {
    step: "01",
    title: "选择通道，建立联系",
    desc: "你可以直接在站内提交线索，也可以只留下一个安全的联系方式。不必一次性交出全部材料，先确认双方都可靠，再决定下一步。",
    points: ["站内匿名表单", "加密邮箱私信", "支持仅留下联系方式"],
  },
  {
    step: "02",
    title: "提供原始素材",
    desc: "原始文件优于转述，完整链路优于单点截图。请尽量保留文件属性与获取方式，这些细节决定了材料能不能被采信。",
    points: ["保留原始文件", "说明获取方式", "补充时间与地点"],
  },
  {
    step: "03",
    title: "核实、脱敏、呈现",
    desc: "我们会交叉核验材料，向你回问疑点，并对可识别你身份的信息做脱敏处理，再与你确认最终的呈现方式与时间。",
    points: ["交叉核验", "身份脱敏", "与你确认呈现方式"],
  },
];

export const verifyFlow = [
  { title: "接收与登记", desc: "线索进入加密队列，仅核实小组成员可读，系统保留最小必要记录。" },
  { title: "初步研判", desc: "判断线索是否具备可核实的事实要素，是否有公共价值，是否需要优先处理。" },
  { title: "交叉核验", desc: "与公开信息、内部文件、旁证材料互相印证，剔除孤证与传闻成分。" },
  { title: "安全脱敏", desc: "对文件名、元数据、可识别特征做处理，降低你被反查的风险。" },
  { title: "呈现决策", desc: "与你确认呈现范围与时间，必要时延后发布以保护当事人。" },
  { title: "回访与保护", desc: "发布后持续跟进，遇到风险苗头第一时间告知你并调整策略。" },
];

export const reportDirections = [
  "政府采购与招投标",
  "食品药品与生产安全",
  "金融借贷与资金池",
  "环境排放与化工隐患",
  "数据合规与个人信息",
  "基层补贴与民生资金",
  "平台规则与算法争议",
  "医疗与教育收费",
];

export const voices = [
  {
    quote: "我一开始只发了一张截图，他们回问了三个问题，都是我没想过要说清楚的细节。后来我才敢把整份文件交出去。",
    meta: "前采购岗 · 已呈现线索",
  },
  {
    quote: "整个过程里没有人问我是谁，也没有人催我。最难得的是他们会告诉我哪些内容不能发，理由是保护我。",
    meta: "制造业内部员工",
  },
  {
    quote: "材料交出去以后我一度很慌，他们给了我一个明确的时间表，什么阶段做什么事，心里就踏实了。",
    meta: "匿名投稿者",
  },
];